import { render, staticRenderFns } from "./ImageTextAdvSelector.vue?vue&type=template&id=2f686f84&scoped=true&"
import script from "./ImageTextAdvSelector.vue?vue&type=script&lang=js&"
export * from "./ImageTextAdvSelector.vue?vue&type=script&lang=js&"
import style0 from "./ImageTextAdvSelector.vue?vue&type=style&index=0&id=2f686f84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f686f84",
  null
  
)

export default component.exports